export const REFRESH_ALL_DATA = 'REFRESH_ALL_DATA';
export const FETCH_DATA = 'FETCH_DATA';
export const FETCH_SPECIFIC_DATA = 'FETCH_SPECIFIC_DATA';

// Groups edition
export const FETCH_GROUPS = 'FETCH_GROUPS';
export const SET_GROUPS = 'SET_GROUPS';
export const CREATE_GROUP = 'CREATE_GROUP';
export const EDIT_GROUP = 'EDIT_GROUP';
export const DELETE_GROUP = 'DELETE_GROUP';


export default {
  REFRESH_ALL_DATA,
  FETCH_DATA,
  FETCH_SPECIFIC_DATA,

  FETCH_GROUPS,
  SET_GROUPS,
  CREATE_GROUP,
  EDIT_GROUP,
  DELETE_GROUP,
};
